import { ApiError, type ApiClient } from '../../api/client';
import type { ContractChange, EmploymentContractApi } from '../../features/rewards/public';

export function createEmploymentContractHttpAdapter(client: ApiClient): EmploymentContractApi {
  const changePath = (id: string) => `/api/hr/v1/{tenant}/employmentContractChanges/${encodeURIComponent(id)}`;
  return {
    getContracts(workerId, asOf) {
      return client.requestTenant(`/api/hr/v1/{tenant}/workers/${encodeURIComponent(workerId)}/employmentContracts?asOf=${encodeURIComponent(asOf)}`);
    },
    async listChanges(workerId) {
      const result = await client.requestTenant<{ data: ContractChange[] }>(`/api/hr/v1/{tenant}/workers/${encodeURIComponent(workerId)}/employmentContractChanges`);
      return result.data;
    },
    getChange(id) { return client.requestTenant(changePath(id)); },
    create(input, key) {
      return client.requestTenant('/api/hr/v1/{tenant}/employmentContractChanges', { method: 'POST', headers: { 'Idempotency-Key': key }, body: JSON.stringify(input) });
    },
    update(id, input, key) {
      return client.requestTenant(changePath(id), { method: 'PATCH', headers: { 'Idempotency-Key': key }, body: JSON.stringify(input) });
    },
    transition(id, action, version, key) {
      return client.requestTenant(`${changePath(id)}/${action}`, { method: 'POST', headers: { 'Idempotency-Key': key }, body: JSON.stringify({ expectedVersion: version }) });
    },
    cancelPending(eventId, key) { return client.cancelBusinessProcessEvent(eventId, '계약 변경 요청 취소', key); },
    isDefinitiveFailure(error) { return error instanceof ApiError && error.status < 500; },
  };
}
